
import { Bed, Bath, Home, Waves, Dog, Utensils, Tv, Coffee, Car, Fan } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";

const features = [
  { 
    icon: Bed, 
    title: "Primary Bedroom", 
    description: "Luxurious king-size bed, flat-screen TV, ceiling fan, and ensuite bathroom with shower" 
  },
  { 
    icon: Bed, 
    title: "Second Bedroom", 
    description: "Comfortable queen-size bed with ceiling fan and ample storage" 
  },
  { 
    icon: Bath, 
    title: "Two Full Bathrooms", 
    description: "Hall bathroom with tub/shower combo plus primary ensuite" 
  },
  { 
    icon: Home, 
    title: "Living/Dining Area", 
    description: "All new furnishings, ceiling fan, and large flat-screen TV" 
  },
  { 
    icon: Utensils, 
    title: "Modern Kitchen", 
    description: "New appliances, cabinetry, upscale cookware and accessories" 
  },
  { 
    icon: Coffee, 
    title: "Private Balcony", 
    description: "Enjoy morning coffee or evening cocktails with rooftop views" 
  },
  { 
    icon: Car, 
    title: "Parking & Storage", 
    description: "Two spaces (one covered) plus ground-level beach storage" 
  },
  { 
    icon: Waves, 
    title: "Beach & Pool Access", 
    description: "2-min walk to beach, private community pool, BBQ grills" 
  },
  { 
    icon: Dog, 
    title: "Pet Friendly", 
    description: "Pets under 30lbs welcome with approval and deposit" 
  },
];

const Features = () => {
  return (
    <section className="py-16 px-4 bg-background">
      <div className="max-w-6xl mx-auto">
        <div className="mb-12 text-center">
          <h2 className="text-3xl font-bold mb-6">Property Features</h2>
          <div className="max-w-3xl mx-auto space-y-4">
            <p className="text-lg text-muted-foreground">
              This charming two-bedroom condo is in Sundune Village located in the heart of Kill Devil Hills at Mile Post 9. BeachBreak offers a comfortable, upscale coastal vibe and has been completely renovated and refurnished for 2025.
            </p>
            <p className="text-lg text-muted-foreground">
              Besides being only a 2-minute walk to the Martin Street beach access, the central location lets you easily enjoy a variety of dining and shopping. One visit to BeachBreak is guaranteed to have you booking it again for your next OBX getaway!
            </p>
          </div>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {features.map((feature, index) => (
            <Card key={index} className="fade-in" style={{ animationDelay: `${index * 100}ms` }}>
              <CardContent className="p-6">
                <feature.icon className="h-8 w-8 text-primary mb-4" />
                <h3 className="font-semibold text-xl mb-2">{feature.title}</h3>
                <p className="text-muted-foreground">{feature.description}</p>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Features;
